import React from "react"
import { usePageTitle } from "../hooks/TitleHook"

const GroundControl = () => {
	usePageTitle("BlueHalo - Ground Control")

	return (
		<div style={{ padding: '40px', textAlign: 'center' }}>
			<h1>Ground Control</h1>
			<p>This page intentionally left blank</p>
		</div>
	)
}

export default GroundControl
